import * as React from 'react';
import LocalDiv from '../../../../localization/LocalDiv';
import LocalInput from '../../../../localization/LocalInput';
import { Str } from '../../../../localization/translationKeys';
import LocalBtn from '../../../../localization/LocalBtn';
import { btnStyle } from '../../../../forms/styles/button';
import { COLORS } from '../../../../globalStyle/colors';
import { css } from '@emotion/core';
import { INPUT } from '../../../../forms/styles/input';
import { FLEX_ADAPTIVE_MED, FLEX_COLUMN } from '../../../../layout/flexBox';
import { useFormik } from 'formik';
import { searchDirectoryFormValidation } from './formValidations';
import { FIELDSET_DEFAULT } from '../../../../layout/fieldSetStyle';
import { onMobileMedium } from '../../../../globalStyle/mediaQueries';


const styles = {
  root:   css`
    flex-wrap: wrap;
    & input, & button {
      margin: 4px;
    }
  `,
  input:  css`
    width: 320px;
    height: 35px;

    ${onMobileMedium} {
      width: unset;
    }
  `,
  button: css`
    min-width: 144px;
    height: 35px;
  `,
};


type Props = {
  className?: string;
  setSearchTerm: (searchTerm: string) => void;
};


/**
 * SearchDirectoryForm: a component that provides a form to search the rater directory for raters by name, email, or Id.
 *
 * PureComponent: true
 * Redux Connected: false
 */
const SearchDirectoryForm: React.FC<Props> = props => {
  const { handleSubmit, handleChange, resetForm, values } = useFormik({
    initialValues:      {
      searchTerm: '',
    },
    onSubmit:           (values) => {
      props.setSearchTerm(values.searchTerm);
      resetForm();
    },
    validationSchema:   searchDirectoryFormValidation,
    validateOnChange:   false,
    enableReinitialize: true,
  });

  return (
    <LocalDiv css={[FLEX_COLUMN, css`${onMobileMedium} { flex-basis: 100%; }`]}>
      <fieldset css={FIELDSET_DEFAULT}>
        <form onSubmit={handleSubmit}>
          <LocalDiv css={[FLEX_ADAPTIVE_MED, styles.root]}>
            <LocalInput
              placeholderTranslation={Str.NameOrEmail}
              name='searchTerm'
              type='text'
              value={values.searchTerm}
              css={[INPUT(COLORS.WHITE), styles.input]}
              onChange={handleChange}
            />
            <LocalBtn
              type='submit'
              css={[btnStyle.primary(COLORS.DARK_GREY), styles.button]}
              str={Str.Search}
              disabled={!values.searchTerm}
            />
          </LocalDiv>
        </form>
      </fieldset>
    </LocalDiv>
  );
};

export default SearchDirectoryForm;
